import script from "./ContactDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactDetails.vue?vue&type=script&setup=true&lang=ts"

import "./ContactDetails.vue?vue&type=style&index=0&id=01028bca&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01028bca"]])

export default __exports__